import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { GlobalStateContext } from '../context/GlobalStateContext';

// Helper: get from localStorage or cookie (same as in Login.js)
function getStorageWithCookie(key) {
  try {
    const v = localStorage.getItem(key);
    if (v !== null) return v;
  } catch (e) {}
  const match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

const ProtectedRoute = ({ adminOnly = false }) => {
  const { authenticatedStudent } = useContext(GlobalStateContext);
  // Читается синхронно: раньше это делалось в эффекте, и каждая защищённая
  // страница начиналась с голого «Loading...» без стилей.
  const isAuthenticated = getStorageWithCookie('isAuthenticated') === 'true';
  const isAdmin = getStorageWithCookie('isAdmin') === 'true';

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Админ, вошедший до перехода на серверную проверку, не получил пропуска
  // к паролям учеников. Один раз просим войти заново — дальше пропуск
  // живёт 180 дней.
  if (isAdmin && !localStorage.getItem('adminToken')) {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('isAdmin');
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to={`/dashboard/${authenticatedStudent?.id}`} replace />;
  }

  // Only redirect students if they're trying to access admin paths
  // Allow students to access their own student page
  //
  // /read — курс чтения, ради него ученик сюда и заходит. Без этого исключения
  // получалась петля: вход вёл на /read, охрана возвращала на /dashboard/:id,
  // а тот переводил обратно на /read. Браузер такое обрывает сам, и страница
  // оставалась пустой.
  if (!isAdmin && 
      !window.location.pathname.startsWith('/read') &&
      !window.location.pathname.startsWith(`/dashboard/${authenticatedStudent?.id}`) && 
      !window.location.pathname.startsWith(`/students/${authenticatedStudent?.id}`)
  ) {
    return <Navigate to={`/dashboard/${authenticatedStudent?.id}`} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;